import React from 'react'
import { useSelector } from 'react-redux'
import useTrans from '@hooks/useTrans'
import { ArticoloType, RootStateType } from '@utils/types'
import { cn, getUserType } from '@utils/safeTs'
import { WImage } from '@components/atoms'
import styles from './MyAccountArticoloOrdine.module.sass'


interface Props {
  articolo?: ArticoloType
  variant?: 'default' | 'onlyProducts'
  quantita?: number
  nota?: string
  className?: string
}

const MyAccountArticoloOrdine = (props: Props) => {

  const { 
    articolo,
    quantita,
    nota,
    variant = 'default',
    className = '',
  } = props

  const t = useTrans()
  const { utente } = useSelector((state: RootStateType) => state.utente)
  const userType = getUserType(utente)

  const details = [
    { key: 'colore', label: t("Colore"), value: articolo?.attributiLista?.filter(a => a.attributoChiave === 'colore')?.[0]?.nome },
    { key: 'quantita', label: t("Quantità"), value: quantita },
  ].filter(x => !!x.value)

  return articolo ? (
    <article  className={cn(styles.root, className)}>
      <div className={styles.imageBox}>
        {!!articolo.mainImage?.url && (
          <WImage
            src={articolo.mainImage.url}
            maxWidth={80}
            maxHeight={80}
            objectFit='contain'
            alt={
              articolo.mainImage?.alt ||
              articolo.codice
                ? t('Immagine prodotto {0}', [articolo.codice])
                : t('Anteprima prodotto')
            }
          />
        )}
      </div>
      <div className={styles.main}>
        {articolo.codice ? <span className={styles.code}>{articolo.codice}</span> : null}
        {articolo.titolo && userType === 'cliente' && variant !== 'onlyProducts' ? <span className={styles.title}>{articolo.titolo}</span> : null}
        <div className={styles.details}>
          {details.map(x => (
            <span key={x.key}>
              <span className={styles.detailTitle}>{x.label}:</span> {x.value}
            </span>
          ))}
        </div>
        {!!nota && (
          <div className={styles.nota}>
            <span className={styles.notaLabel}>{t("Note:")}</span>
            <span className={styles.notaValue}>{nota}</span>
          </div>
        )}
      </div>
    </article>
  ) : <></>
}

export default MyAccountArticoloOrdine
